import { List } from 'immutable'
import {
  getPmScreenTypeFromResolver,
  getPmScreenSectionSectionIds,
} from 'services/pm-screen'
import { selectUserLanguagePrimary } from 'services/user'
import { EN } from 'services/languages/constants'

export function selectSectionsIds (state) {
  const screenRoot = state.pmScreen

  const screenType = getPmScreenTypeFromResolver(state)

  const language = selectUserLanguagePrimary(state) || EN

  const sectionIds = getPmScreenSectionSectionIds({
    pmScreen: screenRoot,
    screenType,
    language,
  }) || List()

  return sectionIds
}

export default selectSectionsIds
